import {
    GET_CNS_LIST_PROGRESS, GET_CNS_LIST_SUCCESS, GET_CNS_LIST_FAILURE,
    ADD_CNS_PROGRESS, ADD_CNS_SUCCESS, ADD_CNS_FAILURE,
    EDIT_DELETE_CNS_PROGRESS, EDIT_DELETE_CNS_SUCCESS, EDIT_DELETE_CNS_FAILURE,

    RESET_MESSAGE,
    UPLOAD_CNS_EXCEL_PROGRESS,
    UPLOAD_CNS_EXCEL_SUCCESS,
    UPLOAD_CNS_EXCEL_FAILURE,

} from '../types/actionTypes';

const initialState = {
    CNS: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const customer_supplier_CNS_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CNS_LIST_SUCCESS:
            return { ...state, CNS: action.CNS, loading: false };
        case GET_CNS_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_CNS_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_CNS_PROGRESS:
            return { ...state, loading: true };
        case ADD_CNS_SUCCESS:
            return { ...state, CNS: [...state.CNS, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_CNS_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };
        case EDIT_DELETE_CNS_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_CNS_SUCCESS:
            return {
                ...state,
                CNS: state.CNS.map((CNS) =>
                    CNS.id === action.payload.id ? action.payload : CNS
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_CNS_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case UPLOAD_CNS_EXCEL_PROGRESS:
            return { ...state, loading: true };
        case UPLOAD_CNS_EXCEL_SUCCESS:
            return { ...state, CNS: [...state.CNS, action.payload], loading: false, error: false, message: 'Record uploaded successfully!' };
        case UPLOAD_CNS_EXCEL_FAILURE:
            return { ...state, loading: false, error: action.payload, message: 'Failed to upload excel file, try again!' };


        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default customer_supplier_CNS_reducer;